var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_3740)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_3740",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.607 0H0V15H16.607V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_3740)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60742 7.5C1.60742 5.51088 2.3976 3.60322 3.80412 2.1967C5.21064 0.790176 7.1183 0 9.10742 0V7.5H1.60742Z",
    fill: "#F16C49"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10352 0C11.0926 0 13.0003 0.790176 14.4068 2.1967C15.8133 3.60322 16.6035 5.51088 16.6035 7.5H9.10352V0Z",
    fill: "#FF8F6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6074 7.49695C16.6074 9.48607 15.8172 11.3937 14.4107 12.8003C13.0042 14.2068 11.0965 14.9969 9.10742 14.9969C7.1183 14.9969 5.21064 14.2068 3.80412 12.8003C2.3976 11.3937 1.60742 9.48607 1.60742 7.49695H16.6074Z",
    fill: "#D75032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833 3.22705H7.549C7.76871 3.2289 7.97879 3.31748 8.1335 3.4735C8.28821 3.62951 8.37501 3.84033 8.375 4.06005V10.8731C8.37501 11.0928 8.28821 11.3036 8.1335 11.4596C7.97879 11.6156 7.76871 11.7042 7.549 11.706H0.833C0.612156 11.7058 0.400433 11.6179 0.244272 11.4618C0.0881119 11.3056 0.000264643 11.0939 0 10.8731L0 4.06506C0.000264643 3.84421 0.0881119 3.63249 0.244272 3.47633C0.400433 3.32017 0.612156 3.23232 0.833 3.23206",
    fill: "#BD3819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44531 9.79298V5.13598H3.92131C4.28351 5.12188 4.64618 5.14601 5.00331 5.20797C5.27248 5.27531 5.50786 5.43851 5.66531 5.66697C5.85074 5.93117 5.94292 6.24958 5.92731 6.57197C5.93827 6.86982 5.86066 7.16424 5.70431 7.41798C5.56896 7.63361 5.36919 7.80118 5.13331 7.89697C4.75281 8.01007 4.35567 8.05675 3.95931 8.03497H3.35931V9.79298H2.44531ZM3.35731 5.92297V7.24798H3.86931C4.10423 7.25945 4.33963 7.23961 4.56931 7.18898C4.6899 7.15104 4.79508 7.0753 4.86931 6.97297C4.95005 6.86042 4.99152 6.72443 4.98731 6.58598C4.99255 6.44522 4.95106 6.30669 4.86931 6.19198C4.7924 6.09238 4.68816 6.01732 4.56931 5.97598C4.32063 5.93115 4.06782 5.91337 3.81531 5.92297H3.35731Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_3740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.607,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.1af916722f9b00b541ca9752af18a64f.svg";
export { ForwardRef as ReactComponent };